/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AccountDto } from '../models/account-dto';
import { addOneSignal } from '../fn/user-profile-api/add-one-signal';
import { AddOneSignal$Params } from '../fn/user-profile-api/add-one-signal';
import { agreeWithPrivacy } from '../fn/user-profile-api/agree-with-privacy';
import { AgreeWithPrivacy$Params } from '../fn/user-profile-api/agree-with-privacy';
import { agreeWithTerms } from '../fn/user-profile-api/agree-with-terms';
import { AgreeWithTerms$Params } from '../fn/user-profile-api/agree-with-terms';
import { delete$ } from '../fn/user-profile-api/delete';
import { Delete$Params } from '../fn/user-profile-api/delete';
import { deleteAuthProvider } from '../fn/user-profile-api/delete-auth-provider';
import { DeleteAuthProvider$Params } from '../fn/user-profile-api/delete-auth-provider';
import { getAllNotifications } from '../fn/user-profile-api/get-all-notifications';
import { GetAllNotifications$Params } from '../fn/user-profile-api/get-all-notifications';
import { getNotificationMethods } from '../fn/user-profile-api/get-notification-methods';
import { GetNotificationMethods$Params } from '../fn/user-profile-api/get-notification-methods';
import { getNotificationOption } from '../fn/user-profile-api/get-notification-option';
import { GetNotificationOption$Params } from '../fn/user-profile-api/get-notification-option';
import { getNotificationOptions } from '../fn/user-profile-api/get-notification-options';
import { GetNotificationOptions$Params } from '../fn/user-profile-api/get-notification-options';
import { getNotificationsUnreadCount } from '../fn/user-profile-api/get-notifications-unread-count';
import { GetNotificationsUnreadCount$Params } from '../fn/user-profile-api/get-notifications-unread-count';
import { getNotificationTypes } from '../fn/user-profile-api/get-notification-types';
import { GetNotificationTypes$Params } from '../fn/user-profile-api/get-notification-types';
import { getOneSignalAppId } from '../fn/user-profile-api/get-one-signal-app-id';
import { GetOneSignalAppId$Params } from '../fn/user-profile-api/get-one-signal-app-id';
import { getUserAccount } from '../fn/user-profile-api/get-user-account';
import { GetUserAccount$Params } from '../fn/user-profile-api/get-user-account';
import { getUserProfile } from '../fn/user-profile-api/get-user-profile';
import { GetUserProfile$Params } from '../fn/user-profile-api/get-user-profile';
import { invalidatePrivacyAgreement } from '../fn/user-profile-api/invalidate-privacy-agreement';
import { InvalidatePrivacyAgreement$Params } from '../fn/user-profile-api/invalidate-privacy-agreement';
import { invalidateTermsAgreement } from '../fn/user-profile-api/invalidate-terms-agreement';
import { InvalidateTermsAgreement$Params } from '../fn/user-profile-api/invalidate-terms-agreement';
import { markNotificationRead } from '../fn/user-profile-api/mark-notification-read';
import { MarkNotificationRead$Params } from '../fn/user-profile-api/mark-notification-read';
import { markNotificationsRead } from '../fn/user-profile-api/mark-notifications-read';
import { MarkNotificationsRead$Params } from '../fn/user-profile-api/mark-notifications-read';
import { NotificationOptionDto } from '../models/notification-option-dto';
import { PageDtoNotificationNotificationDto } from '../models/page-dto-notification-notification-dto';
import { sendEmailVerificationCode } from '../fn/user-profile-api/send-email-verification-code';
import { SendEmailVerificationCode$Params } from '../fn/user-profile-api/send-email-verification-code';
import { sendPhoneValidationCode } from '../fn/user-profile-api/send-phone-validation-code';
import { SendPhoneValidationCode$Params } from '../fn/user-profile-api/send-phone-validation-code';
import { SimpleList } from '../models/simple-list';
import { SimpleNumValue } from '../models/simple-num-value';
import { SimpleValue } from '../models/simple-value';
import { updateProfile } from '../fn/user-profile-api/update-profile';
import { UpdateProfile$Params } from '../fn/user-profile-api/update-profile';
import { updateUserNotificationOption } from '../fn/user-profile-api/update-user-notification-option';
import { UpdateUserNotificationOption$Params } from '../fn/user-profile-api/update-user-notification-option';
import { updateUserPassword } from '../fn/user-profile-api/update-user-password';
import { UpdateUserPassword$Params } from '../fn/user-profile-api/update-user-password';
import { UserDto } from '../models/user-dto';
import { verifyEmailCode } from '../fn/user-profile-api/verify-email-code';
import { VerifyEmailCode$Params } from '../fn/user-profile-api/verify-email-code';
import { verifyPhoneCode } from '../fn/user-profile-api/verify-phone-code';
import { VerifyPhoneCode$Params } from '../fn/user-profile-api/verify-phone-code';

@Injectable({ providedIn: 'root' })
export class UserProfileApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserProfile()` */
  static readonly GetUserProfilePath = '/api/user/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile$Response(params?: GetUserProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return getUserProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserProfile(params?: GetUserProfile$Params, context?: HttpContext): Observable<UserDto> {
    return this.getUserProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `updateProfile()` */
  static readonly UpdateProfilePath = '/api/user/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfile$Response(params: UpdateProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDto>> {
    return updateProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProfile(params: UpdateProfile$Params, context?: HttpContext): Observable<UserDto> {
    return this.updateProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserDto>): UserDto => r.body)
    );
  }

  /** Path part for operation `delete()` */
  static readonly DeletePath = '/api/user/profile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `delete()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete$Response(params: Delete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return delete$(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `delete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  delete(params: Delete$Params, context?: HttpContext): Observable<void> {
    return this.delete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateUserPassword()` */
  static readonly UpdateUserPasswordPath = '/api/user/profile/password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPassword$Response(params: UpdateUserPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUserPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserPassword(params: UpdateUserPassword$Params, context?: HttpContext): Observable<void> {
    return this.updateUserPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNotificationOption()` */
  static readonly GetNotificationOptionPath = '/api/user/profile/notifications/options/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationOption()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOption$Response(params: GetNotificationOption$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationOptionDto>> {
    return getNotificationOption(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationOption$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOption(params: GetNotificationOption$Params, context?: HttpContext): Observable<NotificationOptionDto> {
    return this.getNotificationOption$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationOptionDto>): NotificationOptionDto => r.body)
    );
  }

  /** Path part for operation `updateUserNotificationOption()` */
  static readonly UpdateUserNotificationOptionPath = '/api/user/profile/notifications/options/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserNotificationOption()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserNotificationOption$Response(params: UpdateUserNotificationOption$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationOptionDto>> {
    return updateUserNotificationOption(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserNotificationOption$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUserNotificationOption(params: UpdateUserNotificationOption$Params, context?: HttpContext): Observable<NotificationOptionDto> {
    return this.updateUserNotificationOption$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationOptionDto>): NotificationOptionDto => r.body)
    );
  }

  /** Path part for operation `sendPhoneValidationCode()` */
  static readonly SendPhoneValidationCodePath = '/api/user/profile/validate/phone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendPhoneValidationCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendPhoneValidationCode$Response(params?: SendPhoneValidationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendPhoneValidationCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendPhoneValidationCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendPhoneValidationCode(params?: SendPhoneValidationCode$Params, context?: HttpContext): Observable<void> {
    return this.sendPhoneValidationCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `verifyPhoneCode()` */
  static readonly VerifyPhoneCodePath = '/api/user/profile/validate/phone';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyPhoneCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  verifyPhoneCode$Response(params: VerifyPhoneCode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return verifyPhoneCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyPhoneCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  verifyPhoneCode(params: VerifyPhoneCode$Params, context?: HttpContext): Observable<void> {
    return this.verifyPhoneCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sendEmailVerificationCode()` */
  static readonly SendEmailVerificationCodePath = '/api/user/profile/validate/email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendEmailVerificationCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmailVerificationCode$Response(params?: SendEmailVerificationCode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return sendEmailVerificationCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendEmailVerificationCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendEmailVerificationCode(params?: SendEmailVerificationCode$Params, context?: HttpContext): Observable<void> {
    return this.sendEmailVerificationCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `verifyEmailCode()` */
  static readonly VerifyEmailCodePath = '/api/user/profile/validate/email';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyEmailCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  verifyEmailCode$Response(params: VerifyEmailCode$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return verifyEmailCode(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyEmailCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  verifyEmailCode(params: VerifyEmailCode$Params, context?: HttpContext): Observable<void> {
    return this.verifyEmailCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addOneSignal()` */
  static readonly AddOneSignalPath = '/api/user/profile/onesignal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOneSignal()` instead.
   *
   * This method doesn't expect any request body.
   */
  addOneSignal$Response(params: AddOneSignal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addOneSignal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addOneSignal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addOneSignal(params: AddOneSignal$Params, context?: HttpContext): Observable<void> {
    return this.addOneSignal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `markNotificationRead()` */
  static readonly MarkNotificationReadPath = '/api/user/profile/notifications/{id}/read';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markNotificationRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationRead$Response(params: MarkNotificationRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return markNotificationRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markNotificationRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationRead(params: MarkNotificationRead$Params, context?: HttpContext): Observable<void> {
    return this.markNotificationRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `markNotificationsRead()` */
  static readonly MarkNotificationsReadPath = '/api/user/profile/notifications/read';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `markNotificationsRead()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationsRead$Response(params?: MarkNotificationsRead$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return markNotificationsRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `markNotificationsRead$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  markNotificationsRead(params?: MarkNotificationsRead$Params, context?: HttpContext): Observable<void> {
    return this.markNotificationsRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreeWithTerms()` */
  static readonly AgreeWithTermsPath = '/api/user/profile/agreements/terms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreeWithTerms()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreeWithTerms$Response(params?: AgreeWithTerms$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreeWithTerms(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreeWithTerms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreeWithTerms(params?: AgreeWithTerms$Params, context?: HttpContext): Observable<void> {
    return this.agreeWithTerms$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `invalidateTermsAgreement()` */
  static readonly InvalidateTermsAgreementPath = '/api/user/profile/agreements/terms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invalidateTermsAgreement()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidateTermsAgreement$Response(params?: InvalidateTermsAgreement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invalidateTermsAgreement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invalidateTermsAgreement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidateTermsAgreement(params?: InvalidateTermsAgreement$Params, context?: HttpContext): Observable<void> {
    return this.invalidateTermsAgreement$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `agreeWithPrivacy()` */
  static readonly AgreeWithPrivacyPath = '/api/user/profile/agreements/privacy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `agreeWithPrivacy()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreeWithPrivacy$Response(params?: AgreeWithPrivacy$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return agreeWithPrivacy(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `agreeWithPrivacy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  agreeWithPrivacy(params?: AgreeWithPrivacy$Params, context?: HttpContext): Observable<void> {
    return this.agreeWithPrivacy$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `invalidatePrivacyAgreement()` */
  static readonly InvalidatePrivacyAgreementPath = '/api/user/profile/agreements/privacy';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `invalidatePrivacyAgreement()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidatePrivacyAgreement$Response(params?: InvalidatePrivacyAgreement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return invalidatePrivacyAgreement(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `invalidatePrivacyAgreement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  invalidatePrivacyAgreement(params?: InvalidatePrivacyAgreement$Params, context?: HttpContext): Observable<void> {
    return this.invalidatePrivacyAgreement$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOneSignalAppId()` */
  static readonly GetOneSignalAppIdPath = '/api/user/profile/onesignal/appId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneSignalAppId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneSignalAppId$Response(params?: GetOneSignalAppId$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleValue>> {
    return getOneSignalAppId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneSignalAppId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneSignalAppId(params?: GetOneSignalAppId$Params, context?: HttpContext): Observable<SimpleValue> {
    return this.getOneSignalAppId$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleValue>): SimpleValue => r.body)
    );
  }

  /** Path part for operation `getAllNotifications()` */
  static readonly GetAllNotificationsPath = '/api/user/profile/notifications';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllNotifications$Response(params?: GetAllNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDtoNotificationNotificationDto>> {
    return getAllNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllNotifications(params?: GetAllNotifications$Params, context?: HttpContext): Observable<PageDtoNotificationNotificationDto> {
    return this.getAllNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<PageDtoNotificationNotificationDto>): PageDtoNotificationNotificationDto => r.body)
    );
  }

  /** Path part for operation `getNotificationsUnreadCount()` */
  static readonly GetNotificationsUnreadCountPath = '/api/user/profile/notifications/unreadCount';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationsUnreadCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationsUnreadCount$Response(params?: GetNotificationsUnreadCount$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleNumValue>> {
    return getNotificationsUnreadCount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationsUnreadCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationsUnreadCount(params?: GetNotificationsUnreadCount$Params, context?: HttpContext): Observable<SimpleNumValue> {
    return this.getNotificationsUnreadCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleNumValue>): SimpleNumValue => r.body)
    );
  }

  /** Path part for operation `getNotificationTypes()` */
  static readonly GetNotificationTypesPath = '/api/user/profile/notifications/types/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationTypes$Response(params?: GetNotificationTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getNotificationTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationTypes(params?: GetNotificationTypes$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getNotificationTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `getNotificationOptions()` */
  static readonly GetNotificationOptionsPath = '/api/user/profile/notifications/options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOptions$Response(params?: GetNotificationOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NotificationOptionDto>>> {
    return getNotificationOptions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationOptions(params?: GetNotificationOptions$Params, context?: HttpContext): Observable<Array<NotificationOptionDto>> {
    return this.getNotificationOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<NotificationOptionDto>>): Array<NotificationOptionDto> => r.body)
    );
  }

  /** Path part for operation `getNotificationMethods()` */
  static readonly GetNotificationMethodsPath = '/api/user/profile/notifications/methods/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotificationMethods()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationMethods$Response(params?: GetNotificationMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<SimpleList>> {
    return getNotificationMethods(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotificationMethods$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotificationMethods(params?: GetNotificationMethods$Params, context?: HttpContext): Observable<SimpleList> {
    return this.getNotificationMethods$Response(params, context).pipe(
      map((r: StrictHttpResponse<SimpleList>): SimpleList => r.body)
    );
  }

  /** Path part for operation `getUserAccount()` */
  static readonly GetUserAccountPath = '/api/user/profile/account';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserAccount()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAccount$Response(params?: GetUserAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountDto>> {
    return getUserAccount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserAccount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserAccount(params?: GetUserAccount$Params, context?: HttpContext): Observable<AccountDto> {
    return this.getUserAccount$Response(params, context).pipe(
      map((r: StrictHttpResponse<AccountDto>): AccountDto => r.body)
    );
  }

  /** Path part for operation `deleteAuthProvider()` */
  static readonly DeleteAuthProviderPath = '/api/user/profile/account/auth/provider';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuthProvider()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthProvider$Response(params?: DeleteAuthProvider$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuthProvider(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuthProvider$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthProvider(params?: DeleteAuthProvider$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuthProvider$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
